import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/Logo_RZ_kurz_hell_ claim.svg";
import IconKontaktGreen from "../assets/Icons_Kontakt_grün.svg";
import ContactModal from "./ContactModal";
import styles from "./Header.module.css";

export default function Header() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <Link to="/" className={styles.headerLogo}>
          <img src={Logo} alt="Stahlfaktor - Smarter Solutions" />
        </Link>
      </div>

      <button
        className={styles.kontaktDesktop}
        onClick={() => setIsModalOpen(true)}
        aria-label="Kontakt öffnen"
      >
        <svg preserveAspectRatio="none">
          <line
            x1="16"
            y1="0"
            x2="100%"
            y2="0"
            stroke="var(--color-lime)"
            strokeWidth="1.4"
          />
          <line
            x1="16"
            y1="0"
            x2="0"
            y2="46"
            stroke="var(--color-lime)"
            strokeWidth="1.4"
          />
          <line
            x1="0"
            y1="46"
            x2="100%"
            y2="46"
            stroke="var(--color-lime)"
            strokeWidth="1.4"
          />
        </svg>
        <div className={styles.kontaktDesktopContent}>
          <span>Kontakt</span>
          <img
            className={styles.kontaktIcon}
            src={IconKontaktGreen}
            alt=""
            aria-hidden="true"
          />
        </div>
      </button>

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </header>
  );
}
